import { ISaveMapaConcretagemFiltroUseCase } from "../../../presentation/useCases/update/save_mapa_concretagem_filtro_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * SaveMapaConcretagemFiltroUseCase
 */

export class SaveMapaConcretagemFiltroUseCase implements ISaveMapaConcretagemFiltroUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async saveMapaConcretagemFiltro(params: {
    idObra: number,
    dataConcretagem: boolean,
    tipoDoConcretoSolicitado: boolean,
    slumpSolicit: boolean,
    ensaioDoConcreto: boolean,
    resistMpa: boolean,
    moduloResistenciaGPA: boolean,
    ensaioModuloElasticidade: boolean,
    fornecedor: boolean,
    nroDoCarro: boolean,
    nroNotaFiscal: boolean,
    saidaUsina: boolean,
    entObra: boolean,
    inicioLanc: boolean,
    finalLanc: boolean,
    qtdeM3: boolean,
    slump: boolean,
    localDeLancamento: boolean,
    dataDeEnvioDaObra: boolean,
    laboratorio: boolean,
    nroCorpoDeProva: boolean,
    nroLote: boolean,
    nroLaudo: boolean,
    instrucaoDeRompimento: boolean,
    enviadoParaOLaboratorio: boolean,
    dataDeEnvioParaOLaboratorio: boolean,
    dozeHoras: boolean,
    dataDozeHoras: boolean,
    quatroDias: boolean,
    dataQuatroDias: boolean,
    seteDias: boolean,
    dataSeteDias: boolean,
    quatorzeDias: boolean,
    dataQuatorzeDias: boolean,
    vinteUmDias: boolean,
    dataVinteUmDias: boolean,
    vinteOitoDias: boolean,
    dataVinteOitoDias: boolean,
    cinquentaSeisDias: boolean,
    dataCinquentaSeisDias: boolean,
    sessentaTresDias: boolean,
    dataSessentaTresDias: boolean,
    elasticidade28: boolean,
    dataElasticidade28: boolean,
    outrasIdades1: boolean,
    dataOutrasIdades1: boolean,
    outrasIdades2: boolean,
    dataOutrasIdades2: boolean,
    outrasIdades3: boolean,
    dataOutrasIdades3: boolean,
    aprovado: boolean,
    responsavelPelaAprovacao: boolean,
    dataDaAprovacao: boolean,
    observacao: boolean,
  }): Promise<void> {
    const colunasArr = [];

    if (params.dataConcretagem) { colunasArr.push('DATA_CONCRETAGEM'); }
    if (params.tipoDoConcretoSolicitado) { colunasArr.push('TIPO_CONCRETO'); }
    if (params.slumpSolicit) { colunasArr.push('SLUMP_SOLICIT'); }
    if (params.ensaioDoConcreto) { colunasArr.push('ENSAIO_CONCRETO'); }
    if (params.resistMpa) { colunasArr.push('RESIST_MPA'); }
    if (params.moduloResistenciaGPA) { colunasArr.push('MODULO_RESISTENCIA_GPA'); }
    if (params.ensaioModuloElasticidade) { colunasArr.push('ENSAIO_MODULO_ELASTICIDADE'); }
    if (params.fornecedor) { colunasArr.push('DESC_FORNECEDOR'); }
    if (params.nroDoCarro) { colunasArr.push('NRO_CARRO'); }
    if (params.nroNotaFiscal) { colunasArr.push('NRO_NOTA_FISCAL'); }
    if (params.saidaUsina) { colunasArr.push('SAIDA_USINA'); }
    if (params.entObra) { colunasArr.push('DATA_ENTRADA'); }
    if (params.inicioLanc) { colunasArr.push('DATA_INICIO'); }
    if (params.finalLanc) { colunasArr.push('DATA_FINAL'); }
    if (params.qtdeM3) { colunasArr.push('QTDE_M3'); }
    if (params.slump) { colunasArr.push('SLUMP'); }
    if (params.localDeLancamento) { colunasArr.push('LOCAL_LANCAMENTO'); }
    if (params.dataDeEnvioDaObra) { colunasArr.push('DATA_ENVIO'); }
    if (params.laboratorio) { colunasArr.push('LABORATORIO'); }
    if (params.nroCorpoDeProva) { colunasArr.push('NUMERO_CORPO_PROVA'); }
    if (params.nroLote) { colunasArr.push('NUMERO_LOTE'); }
    if (params.nroLaudo) { colunasArr.push('NRO_LAUDO'); }
    if (params.instrucaoDeRompimento) { colunasArr.push('INSTRUCAO_ROMPIMENTO'); }
    if (params.enviadoParaOLaboratorio) { colunasArr.push('ENVIADO_LABORATORIO'); }
    if (params.dataDeEnvioParaOLaboratorio) { colunasArr.push('DATA_ENVIADO_LABORATORIO'); }
    if (params.dozeHoras) { colunasArr.push('RESISTENCIA_12HS'); }
    if (params.dataDozeHoras) { colunasArr.push('DATA_12HS'); }
    if (params.quatroDias) { colunasArr.push('RESISTENCIA_4'); }
    if (params.dataQuatroDias) { colunasArr.push('DATA_4'); }
    if (params.seteDias) { colunasArr.push('RESISTENCIA_7'); }
    if (params.dataSeteDias) { colunasArr.push('DATA_7'); }
    if (params.quatorzeDias) { colunasArr.push('RESISTENCIA_14'); }
    if (params.dataQuatorzeDias) { colunasArr.push('DATA_14'); }
    if (params.vinteUmDias) { colunasArr.push('RESISTENCIA_21'); }
    if (params.dataVinteUmDias) { colunasArr.push('DATA_21'); }
    if (params.vinteOitoDias) { colunasArr.push('RESISTENCIA_28'); }
    if (params.dataVinteOitoDias) { colunasArr.push('DATA_28'); }
    if (params.cinquentaSeisDias) { colunasArr.push('RESISTENCIA_56'); }
    if (params.dataCinquentaSeisDias) { colunasArr.push('DATA_56'); }
    if (params.sessentaTresDias) { colunasArr.push('RESISTENCIA_63'); }
    if (params.dataSessentaTresDias) { colunasArr.push('DATA_63'); }
    if (params.elasticidade28) { colunasArr.push('ELASTICIDADE_28'); }
    if (params.dataElasticidade28) { colunasArr.push('DATA_ELASTICIDADE_28'); }
    if (params.outrasIdades1) { colunasArr.push('TEMPO_RESULTADO1'); }
    if (params.dataOutrasIdades1) { colunasArr.push('DATA_OUTRO1'); }
    if (params.outrasIdades2) { colunasArr.push('TEMPO_RESULTADO2'); }
    if (params.dataOutrasIdades2) { colunasArr.push('DATA_OUTRO2'); }
    if (params.outrasIdades3) { colunasArr.push('TEMPO_RESULTADO3'); }
    if (params.dataOutrasIdades3) { colunasArr.push('DATA_OUTRO3'); }
    if (params.aprovado) { colunasArr.push('APROVADO'); }
    if (params.responsavelPelaAprovacao) { colunasArr.push('RESPONSAVEL_APROVACAO'); }
    if (params.dataDaAprovacao) { colunasArr.push('DATA_APROVACAO'); }
    if (params.observacao) { colunasArr.push('OBSERVACAO'); }

    await this.repository.saveMapaConcretagemFiltro(
      params.idObra,
      colunasArr.join(","),
    );
  }
}
